import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    description: {
        id: '_.doc_upload_banner.description',
        defaultMessage:
            'You can upload your bank statements from the past 6 months or link Open Banking {docUploadLink} for a quicker journey next time you need funds'
    }
});
